import ListStore from '@/store/core/ListStore';
import { action, computed } from 'mobx';
import services from '@/api/services';
import { TaxModes } from '@/store/types';
import { dateFormat, numGroup } from '@/utils/filters';

export default class TaxModeStore extends ListStore<TaxModes> {
  @computed get processedData() {
    if (!this.data) return;
    return {
      ...this.data,
    };
  }

  @action.bound async fetch() {
    this.isFetching = true;
    try {
      const { data } = await services.taxModes.getTaxModesList();
      this.data = data;
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}
